/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl, IconButton, RadioControl, Button, TextareaControl } from '@wordpress/components';
import { useState } from '@wordpress/element';

import { Placeholder, Grid, GridColumn } from '@wordpress/components';
import { Fragment } from 'react';
/* import { v4 as uuidv4 } from 'uuid'; */
/**
 * Icons
 */
import icons from './icons.js';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit(props) {
    const { attributes, setAttributes, blockProps, clientId, className } = props;
    const { selectedElement, textContent, textareaContent, selectOptions, radioOptions, checkOptions, elementLabel, elementID } = attributes;
    const getRandomNumber = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    if ( !elementID ) {
        setAttributes({ elementID: getRandomNumber( 10000, 10000000) });
    }
    const handleElementChange = (newElement) => {
      setAttributes({ selectedElement: newElement });
    };

    const handleTextChange = (newText) => {
      setAttributes({ textContent: newText });
    };
    const handleTextareaChange = (newText) => {
        setAttributes({ textareaContent: newText });
      };
    const handleLabelChange = (newText) => {
        setAttributes({ elementLabel: newText });
    };
    const handleIdChange = (newText) => {
        setAttributes({ elementID: newText });
    };

    const handleSelectLabelChange = (newLabel, index) => {
      const updatedOptions = [...selectOptions];
      updatedOptions[index].label = newLabel;
      setAttributes({ selectOptions: updatedOptions });
    };

    const handleRadioLabelChange = (newLabel, index) => {
      const updatedOptions = [...radioOptions];
      updatedOptions[index].label = newLabel;
      setAttributes({ radioOptions: updatedOptions });
    };
    const handleCheckLabelChange = (newLabel, index) => {
        const updatedOptions = [...checkOptions];
        updatedOptions[index].label = newLabel;
        setAttributes({ checkOptions: updatedOptions });
      };

    const addSelectOption = () => {
      setAttributes({
        selectOptions: [...selectOptions, { label: '', value: '' }],
      });
    };

    const deleteSelectOption = (index) => {
      const updatedOptions = [...selectOptions];
      updatedOptions.splice(index, 1);
      setAttributes({ selectOptions: updatedOptions });
    };

    const addRadioOption = () => {
      setAttributes({
        radioOptions: [...radioOptions, { label: '', value: '' }],
      });
    };

    const addCheckOption = () => {
        setAttributes({
          checkOptions: [...checkOptions, { label: '', value: '' }],
        });
      };

    const deleteRadioOption = (index) => {
      const updatedOptions = [...radioOptions];
      updatedOptions.splice(index, 1);
      setAttributes({ radioOptions: updatedOptions });
    };
    const deleteCheckOption = (index) => {
        const updatedOptions = [...checkOptions];
        updatedOptions.splice(index, 1);
        setAttributes({ checkOptions: updatedOptions });
      };

    return (
      <div>
        <InspectorControls>
          <PanelBody title="Block Settings" initialOpen={true}>
            <TextControl
                label={__('Label', 'momoacg')}
                value={elementLabel}
                onChange={handleLabelChange}
            />
            <TextControl
                label={__('Element ID', 'momoacg')}
                value={elementID}
                onChange={handleIdChange}
            />
            <RadioControl
              label={__('Choose Element', 'momoacg')}
              selected={selectedElement}
              options={[
                { label: 'Text', value: 'text' },
                { label: 'Select', value: 'select' },
                { label: 'Radio', value: 'radio' },
                { label: 'Checkbox', value: 'checkbox' },
                { label: 'Textarea', value: 'textarea' },
              ]}
              onChange={handleElementChange}
            />
            {selectedElement === 'text' && (
              <TextControl
                label="placeholder"
                value={textContent}
                onChange={handleTextChange}
              />
            )}
            {selectedElement === 'select' && (
              <Fragment>
                {selectOptions.map((option, index) => (
                  <div key={`select-option-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
                        <TextControl
                        label={`Option ${index + 1}`}
                        value={option.label}
                        onChange={(newLabel) => handleSelectLabelChange(newLabel, index)}
                        />
                        <IconButton
                        isDestructive
                        onClick={() => deleteSelectOption(index)}
                        icon='trash'
                        style={{ marginLeft: '10px' }}
                        />
                  </div>
                ))}
                <Button variant="primary" onClick={addSelectOption}>
                    {__('Add Option', 'momoacg')}
                </Button>
              </Fragment>
            )}
            {selectedElement === 'radio' && (
              <div>
                {radioOptions.map((option, index) => (
                  <div key={`radio-option-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
                    <TextControl
                      label={`Option ${index + 1}`}
                      value={option.label}
                      onChange={(newLabel) => handleRadioLabelChange(newLabel, index)}
                    />
                    <IconButton
                      isDestructive
                      onClick={() => deleteRadioOption(index)}
                      icon='trash'
                      style={{ marginLeft: '10px' }}
                    />
                  </div>
                ))}
                <Button variant="primary" onClick={addRadioOption}>{__('Add Option', 'momoacg')}</Button>
              </div>
            )}
            {selectedElement === 'checkbox' && (
                <div>
                    {checkOptions.map((option, index) => (
                        <div key={`check-option-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
                            <TextControl
                            label={`Option ${index + 1}`}
                            value={option.label}
                            onChange={(newLabel) => handleCheckLabelChange(newLabel, index)}
                            />
                            <IconButton
                            isDestructive
                            onClick={() => deleteCheckOption(index)}
                            icon='trash'
                            style={{ marginLeft: '10px' }}
                            />
                        </div>
                    ))}
                <Button variant="primary" onClick={addCheckOption}>{__('Add Option', 'momoacg')}</Button>
                </div>
            )}
            {selectedElement === 'textarea' && (
                <div>
                    <TextControl
                        label={__('Placeholder', 'momoacg')}
                        value={textareaContent}
                        onChange={handleTextareaChange}
                    />
                </div>
            )}
          </PanelBody>
        </InspectorControls>
        <div>
            <Placeholder
                icon={icons.content}
                label={ __('MoMo Form Element', 'momoacg') }
                isColumnLayout
            >
            {selectedElement === 'text' && (
                <div class="momo-form-element-block">
                    <label>{elementLabel}</label>
                    <div><input type="text" placeholder={textContent}/></div>
                </div>
            )}
            {selectedElement === 'select' && (
                <div class="momo-form-element-block">
                <label>{elementLabel}</label>
                <select>
                    {selectOptions.map((option, index) => (
                    <option key={`select-option-${index}`} value={option.value} >
                        {option.label}
                    </option>
                    ))}
                </select>
                </div>
            )}
            {selectedElement === 'radio' && (
                <div class="momo-form-element-block">
                <label>{elementLabel}</label>
                    {radioOptions.map((option, index) => (
                    <div><input type="radio" id={`radio-option-${index}`} value={option.value}/>
                    <label class="momo-radio-label">{option.label}</label>
                    </div>          
                    ))}
                </div>
            )}
            {selectedElement === 'checkbox' && (
                <div class="momo-form-element-block">
                <label>{elementLabel}</label>
                    {checkOptions.map((option, index) => (
                    <div><input type="checkbox" name={`check-option-${index}`} value={option.value}/>
                    <label class="momo-checkbox-label">{option.label}</label>
                    </div>          
                    ))}
                </div>
            )}
            {selectedElement === 'textarea' && (
                <div class="momo-form-element-block">
                    <label>{elementLabel}</label>
                    <div><textarea cols="5" placeholder={textareaContent}></textarea></div>
                </div>
            )}
            </Placeholder>
        </div>
      </div>
    );
}